// @flow
import React from 'react';

import { ICONS } from 'Components/utils/icon/icons';

import { FooterWebsite } from './footer-website/FooterWebsite.jsx';

type Item = {
  description: string,
  href: string,
  isVisible?: boolean,
};

type FooterWebsitesProps = {
  business: Item,
  className?: string,
  corp: Item,
  job: Item,
  property: Item,
};

export function FooterWebsites({ business, className, corp, job, property }: FooterWebsitesProps) {
  return (
    <div className={className}>
      <ul className="reset-list -mx-3">
        <FooterWebsite
          {...business}
          iconAlt="Meetings and events by Club Med"
          iconName={ICONS.CLUBMED_MEETINGS}
          iconWidth="12.5rem"
        />
        <FooterWebsite
          {...property}
          iconAlt="Club Med Property"
          iconName={ICONS.CLUBMED_PROPERTY}
          iconWidth="7.5rem"
        />
        <FooterWebsite
          {...job}
          iconAlt="ClubMed Jobs"
          iconName={ICONS.CLUBMED_JOBS}
          iconWidth="7.5rem"
        />
        <FooterWebsite
          {...corp}
          iconAlt="Club Méditerranée"
          iconName={ICONS.CLUBMED}
          iconWidth="7.5rem"
        />
      </ul>
    </div>
  );
}
